var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "appLayout",
      attrs: {
        page: "/inbox",
        pageTitle: "Inbox",
        fabIcon: "edit_note",
        hasFab: _vm.can("Create conversations") && !_vm.selectedConversation,
      },
      on: {
        fabAction: function ($event) {
          return _vm.handleCreateMessage()
        },
        messageReceived: _vm.messageReceived,
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "inbox-title flex items-center" },
                [
                  _vm.can("Use CRM") &&
                  _vm.$page.props.staffView &&
                  _vm.$page.props.auth.user.selected_location.crm_enabled
                    ? _c(
                        "v-menu",
                        {
                          attrs: { "offset-y": "", "min-width": "200" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-badge",
                                      {
                                        class: {
                                          "hide-badge":
                                            !_vm.unreadOnly && !_vm.draftsOnly,
                                        },
                                        attrs: { dot: "", overlap: "" },
                                      },
                                      [
                                        _c(
                                          "button",
                                          _vm._g(
                                            {
                                              staticClass:
                                                "cursor-pointer flex gap-1 items-center",
                                              attrs: { type: "button" },
                                            },
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.crmMode
                                                    ? "Studio Inbox"
                                                    : "My Inbox"
                                                ) +
                                                "\n                            "
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  small: "",
                                                  icon: "",
                                                  loading: _vm.settingsLoading,
                                                },
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("keyboard_arrow_down"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3868618942
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(_vm.inboxSettings, function (setting, idx) {
                              return _c(
                                "v-list-item",
                                {
                                  key: setting.name,
                                  staticClass: "gap-2",
                                  on: {
                                    click: function ($event) {
                                      return setting.action()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-content",
                                    { staticClass: "w-min" },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(setting.label)),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-list-item-subtitle", [
                                        _vm._v(
                                          _vm._s(setting.description) +
                                            "\n                            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-action",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: setting.value
                                              ? "accent"
                                              : null,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              setting.value
                                                ? "toggle_on"
                                                : "toggle_off"
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", [_vm._v("Inbox")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.can("Create conversations") &&
                  _vm.$vuetify.breakpoint.mdAndUp
                    ? _c("SoliBtn", {
                        staticClass: "inbox-header-button",
                        attrs: {
                          round: "",
                          small: "",
                          icon: "edit_note",
                          gradient: "gradient-orange",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleCreateMessage()
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-container",
        {
          staticClass:
            "chat-container h-full py-0 px-3 animate__animated animate__fadeIn",
          attrs: { fluid: _vm.$page.props.staffView },
        },
        [
          _c(
            "v-row",
            { staticClass: "chat-row h-full" },
            [
              _c(
                "v-col",
                {
                  staticClass: "chat-index-col flex grow relative py-0",
                  attrs: { cols: "12" },
                },
                [
                  _c("ConversationIndex", {
                    key: _vm.searching,
                    ref: "conversationIndex",
                    attrs: {
                      id: "chat-index",
                      index: _vm.index,
                      thread: _vm.selectedThread,
                      crmMode: _vm.crmMode,
                      searching: _vm.searching,
                      showSearch: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.handleSelectConversation($event)
                      },
                    },
                    model: {
                      value: _vm.selectedConversation,
                      callback: function ($$v) {
                        _vm.selectedConversation = $$v
                      },
                      expression: "selectedConversation",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedConversation
                ? _c(
                    "v-col",
                    { staticClass: "pa-0", attrs: { id: "chat-window" } },
                    [
                      _c("ConversationShow", {
                        key: _vm.conversationKey,
                        ref: "conversationShow",
                        attrs: {
                          conversation: _vm.selectedConversation,
                          conversationUser: _vm.conversationUser,
                          thread: _vm.selectedThread,
                          messages: _vm.selectedConversation?.create
                            ? []
                            : _vm.messages,
                          messageCount: _vm.messageCount,
                          crmClient: _vm.crmClient,
                          errors: _vm.errors,
                          newMessageAvailable: _vm.newMessageAvailable,
                          crmMode: _vm.crmMode,
                          crmLoading: _vm.crmLoading,
                          action: _vm.action,
                          searching: _vm.searching,
                          cursor: _vm.index?.currentCursor,
                        },
                        on: {
                          drafted: function ($event) {
                            return _vm.updateDraft($event)
                          },
                          showMessage: function ($event) {
                            _vm.$refs.appLayout.showMessage = true
                          },
                          changeThread: function ($event) {
                            _vm.selectedThread = $event
                          },
                          handleUnread: function ($event) {
                            return _vm.handleUnread($event)
                          },
                          openCrm: function ($event) {
                            return _vm.handleSelectConversation(
                              _vm.selectedConversation,
                              true
                            )
                          },
                          reset: function ($event) {
                            _vm.closeModal(
                              () => (_vm.selectedConversation = null)
                            )
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.selectedConversation && _vm.$vuetify.breakpoint.mdAndUp
                ? _c(
                    "v-col",
                    { staticClass: "flex justify-center align-center" },
                    [
                      _c(
                        "v-list",
                        { staticClass: "text-align-center" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "my-2",
                              attrs: { "x-large": "", color: "accent" },
                            },
                            [_vm._v("chat_bubble_outline")]
                          ),
                          _vm._v(" "),
                          _c("v-list-item-title", [_vm._v("No chat selected")]),
                          _vm._v(" "),
                          _c("v-list-item-subtitle", [
                            _vm._v("Please select a conversation"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }